import { Box } from '@mui/material';
import { LabelContent, HorizontalForm } from '../../../common';

const DebtEditHeader = ({ selectedItem, plans }) => {
  const selectedPlan = plans.find((plan) => plan.uuid === selectedItem.header.plan);

  return (
    <HorizontalForm
      sx={{
        borderBottom: '1px solid #e0e0e0',
        py: 2,
        minHeight: 'auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 1, md: 4 },
          width: '100%',
        }}
      >
        <LabelContent
          label="Contrato"
          content={selectedItem.header.contract_number}
          labelColor="primary.main"
          sx={{ fontSize: { xs: '14px', md: '16px' }, margin: 0 }}
        />
        <LabelContent
          label="Plan"
          content={selectedPlan?.name || 'N/A'}
          labelColor="primary.main"
          sx={{ fontSize: { xs: '14px', md: '16px' }, margin: 0 }}
        />
        <LabelContent
          label="Suscriptor/s"
          content={selectedItem.header.subscriber}
          labelColor="primary.main"
          sx={{ fontSize: { xs: '14px', md: '16px' }, margin: 0 }}
        />
      </Box>
    </HorizontalForm>
  );
};

export default DebtEditHeader;
